import { render, staticRenderFns } from "./ModalImportHorseDescendants.vue?vue&type=template&id=c0d98a98&"
import script from "./ModalImportHorseDescendants.vue?vue&type=script&lang=js&"
export * from "./ModalImportHorseDescendants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports